export const DATA_BASE_ADDRESS = 'https://tlbxfiles.ir/pwa/';
